import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';

export const hasSearchMatch = (searchQuery, terms) => {
  if (!searchQuery) return true;

  return terms.filter(Boolean).some((term) => matchesSearch(term, searchQuery));
};
